import { BroadcastChannel } from 'broadcast-channel';

export type HPInvalidationMessage = {
  type: 'invalidate';
  /**
   * Set only when the invalidation is a deletion. The other windows need the smid so they can
   * ignore any response still describing that HP, which would otherwise put the step bar back
   * (VX-4738).
   */
  deletedHPSmid?: string;
};

/**
 * Broadcast channel for cross-window HP invalidation.
 * After save/delete on viewer/0, posts a message so viewer/1 can refetch.
 */
const hpInvalidationChannel = new BroadcastChannel<HPInvalidationMessage>('hp-invalidation');

export const broadcastHPInvalidation = (options?: { deletedHPSmid?: string }): void => {
  hpInvalidationChannel.postMessage({ type: 'invalidate', ...options });
};

/** Exposed for useHangingProtocol to listen for invalidation events. */
export { hpInvalidationChannel };
